import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  hasSearchQuery: boolean
}

const EmptyPartnerDriversComponent = ({ hasSearchQuery }: Props) => {
  return (
    <div
      data-testid="partner-drivers-list-empty"
      css={tw`flex h-full w-full flex-col items-center justify-center gap-1`}
    >
      <Typography variant="subtitle1">
        {hasSearchQuery ? 'No drivers match these details' : 'Find a driver'}
      </Typography>
      <Typography variant="body2" css={tw`text-shades-500`}>
        {hasSearchQuery
          ? 'Check the email, phone or ID and try again.'
          : 'Search by email, phone or partner driver ID.'}
      </Typography>
    </div>
  )
}

export const EmptyPartnerDrivers = memo(EmptyPartnerDriversComponent)
